export default __webpack_public_path__ + "44f8071ce36449f1dfe308f28c127492.png";